var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plugin-home-how-it-works-v2-base-item',{attrs:{"item":_vm.item}},[_c('div',{staticClass:"plugin-home-how-it-works-item__image"},[_c('img',{attrs:{"src":_vm.item.image,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }